import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';
import { packageContext } from '../../utils/package-context';
class UFOExperienceWithPackageContext extends UFOExperience {
  async success() {
    return super.success({
      metadata: {
        ...packageContext
      }
    });
  }
  async failure(config) {
    var _config$metadata;
    return super.failure({
      force: config === null || config === void 0 ? void 0 : config.force,
      metadata: {
        ...((_config$metadata = config === null || config === void 0 ? void 0 : config.metadata) !== null && _config$metadata !== void 0 ? _config$metadata : {}),
        ...packageContext
      }
    });
  }
  async abort() {
    return super.abort({
      metadata: {
        ...packageContext
      }
    });
  }
}
export const renderPeopleNavMenuExp = new UFOExperienceWithPackageContext('render-people-nav-menu', {
  type: ExperienceTypes.Experience,
  performanceType: ExperiencePerformanceTypes.InlineResult,
  platform: {
    component: 'people'
  }
});